var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeek15Next(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.1,
    height: 50,
    viewBox: "0 0 52.1 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 52.1,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_15",
    "data-name": 15,
    transform: "translate(-203.984 -986.52)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("text", {
    id: "_15_s",
    "data-name": "15 s",
    transform: "translate(216 1018)",
    fill: "#aeaeae",
    fontSize: 16,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15 s")), /*#__PURE__*/React.createElement("g", {
    id: "Kompozycja_5",
    "data-name": "Kompozycja 5",
    transform: "translate(230.034 1011.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(-26.05 -25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M24.98,0a25,25,0,0,1,22.9,14.9l1.4-3.7,2.8,1-3.4,8.9-8.9-3.4,1.1-2.8,3.8,1.5a21.5,21.5,0,1,0,1.8,9.6h3.5a25,25,0,1,1-25-26",
    transform: "translate(0.02 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeek15Next);
export default __webpack_public_path__ + "static/media/seek_15_next.ccde8caadf3fefc19cf18a89203ed529.svg";
export { ForwardRef as ReactComponent };